import React, { PureComponent } from 'react'
import { IconSectionHeader, Spinner } from '../../../generic'
import ModalQuestion from './ModalQuestion'

interface Option {
  label?: string
  primary?: boolean
  value: any
}

interface AssessmentQuestionScreenProps {
  continueOnPrimaryAction?: boolean
  form: {
    color: string
    iconText: string
    name: string
  }
  note?: string
  onPrimaryAction: (form: AssessmentQuestionScreenProps['form']) => void
  onSecondaryAction?: (form: AssessmentQuestionScreenProps['form']) => void
  goToNextStep?: () => void
  options: Option[]
  question: string
  style?: React.CSSProperties
}

interface AssessmentQuestionScreenState {
  answer: any
}

export default class AssessmentQuestionScreen extends PureComponent<
  AssessmentQuestionScreenProps,
  AssessmentQuestionScreenState
> {
  state: AssessmentQuestionScreenState = {
    answer: null,
  }

  handleAnswer = (answer: { primary?: boolean }) => {
    if (answer.primary) {
      this.handlePrimaryAction()
    } else {
      this.handleSecondaryAction()
    }
  }

  handlePrimaryAction = () => {
    const { continueOnPrimaryAction, form, goToNextStep, onPrimaryAction } =
      this.props

    onPrimaryAction(form)
    if (continueOnPrimaryAction && goToNextStep) goToNextStep()
  }

  handleSecondaryAction = () => {
    const { form, goToNextStep, onSecondaryAction } = this.props

    if (onSecondaryAction) {
      onSecondaryAction(form)
    } else if (goToNextStep) {
      goToNextStep()
    }
  }

  render() {
    const { form, note, options, question, style } = this.props
    if (!form) return <Spinner />
    return (
      <div style={style}>
        <IconSectionHeader
          color={form.color}
          iconText={form.iconText}
          isMainHeader
          title={form.name}
        />
        <ModalQuestion
          // @ts-ignore
          answer={this.state.answer}
          note={note}
          onChange={this.handleAnswer}
          options={options}
          question={question}
          style={styles.question}
        />
      </div>
    )
  }
}

const styles = {
  button: {
    display: 'inline-block',
    float: 'right',
    marginTop: 20,
  },
  question: {
    marginTop: 20,
  },
}
